import {PuiLoadingBackdrop, useAlert} from "@portnet/ui";
import axios from "axios";
import React from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import config from "../../../config";
import {LOCAL_STORAGE_TOKEN_KEY} from "../../../modules/auth/login/state/loginReducer";
import {DEFAULT_ERROR_MESSAGE} from "../../constants/generalConstants";
import {LOGIN_PAGE_ROUTE, NETWORK_ERROR_PAGE_ROUTE, NOT_FOUND_ERROR_PAGE_ROUTE,} from "../../constants/routerConstants";

const instance = axios.create({
  baseURL: config.baseURL,
});

const AxiosInterceptor = ({ children }) => {
  const alertDispatch = useAlert();
  const navigate = useNavigate();

  const [requestInterceptor, setRequestInterceptor] = React.useState(null);

  const [isAppReady, setIsAppReady] = React.useState(false);

  const isLogged = useSelector((state) => Boolean(state.auth.login.user));

  const getErrorStatusAndMessage = (error) => {
    const errorStatus =
      error?.response?.data?.status ?? error?.response?.status;
    const errorMessage = error?.response?.data?.message;
    return [errorStatus, errorMessage];
  };

  const getToken = () => {
  const params = new URLSearchParams(window.location.search);
  const tokenFromUrl = params.get("token");
  return tokenFromUrl || sessionStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
};

  const handleError = (errorStatus, errorMessage) => {
    if (Boolean(errorStatus)) {
      switch (String(errorStatus)) {
        case "404":
          navigate(NOT_FOUND_ERROR_PAGE_ROUTE);
          break;
        // case "500":
        //   navigate(SERVER_ERROR_PAGE_ROUTE);
        //   break;
        case "401": // Handle 401 error
          navigate(LOGIN_PAGE_ROUTE);
          alertDispatch("error", "Session expirée. Veuillez vous reconnecter.");
          break;
        default:
          alertDispatch("error", errorMessage ?? DEFAULT_ERROR_MESSAGE);
          break;
      }
    } else {
      navigate(NETWORK_ERROR_PAGE_ROUTE);
    }
  };


    const configuration = (axiosConfig) => {
    const token = getToken();

    if (token) {
      axiosConfig.headers = {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      };
    }

    return axiosConfig;
  };


  React.useEffect(() => {
  const requestInterceptor = instance.interceptors.request.use(
    (axiosConfig) => configuration(axiosConfig),
    (error) => Promise.reject(error)
  );
  return () => {
    instance.interceptors.request.eject(requestInterceptor);
  };
}, []);

  React.useEffect(() => {
    const interceptor = instance.interceptors.response.use(
      (response) => {
        const responseStatus = response.data.status ?? response.status;
        const responseMessage = response.data.message;
        if (String(responseStatus) !== "200" && Boolean(responseMessage)) {
          alertDispatch("success", responseMessage);
        }
        return Promise.resolve(response);
      },
      (error) => {
        const [errorStatus, errorMessage] = getErrorStatusAndMessage(error);
        handleError(errorStatus, errorMessage);
        return Promise.reject(error);
      }
    );
    setIsAppReady(true);
    return () => instance.interceptors.response.eject(interceptor);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isAppReady ? children : <PuiLoadingBackdrop open={true} />;
};

export { AxiosInterceptor };

export default instance;
